import { Injectable } from '@angular/core';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { BehaviorSubject } from 'rxjs';

export interface ProgressToastUpload {
  id: string;
  type: 'upload';
  gallery: GalleryDto;
}

export interface ProgressToastArchive {
  id: string;
  type: 'archive';
}

export type ProgressToast = ProgressToastUpload | ProgressToastArchive;

@Injectable({
  providedIn: 'root',
})
export class ProgressToastService {
  public toasts$ = new BehaviorSubject<ProgressToast[]>([]);

  addToast(toast: ProgressToast) {
    this.toasts$.next([...this.toasts$.value, toast]);
  }

  removeToast(toastId: string) {
    this.toasts$.next(this.toasts$.value.filter(t => t.id !== toastId));
  }
}
